<template>
  <div v-if="value">
    <DxButton
      text="Aktif"
      type="success"
      width="auto"
      height="18px"
      icon="check"
    />
  </div>
  <div v-else>Tidak Aktif</div>
  <!-- <div v-else>Tidak Aktif</div> -->
</template>

<script>
import DxButton from "devextreme-vue/button";
export default {
  components: {
    DxButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {},
  methods: {},
};
</script>
